import { Company } from "../companies/types"
import { Country } from "../countries/types"

export enum UserRoles {
  ADMIN = 1,
  RECYCLER = 2,
  RECOVINYL_REGIONAL_REPRESENTATIVE = 3,
  AUDITOR = 4,
  SECTOR_ASSOCIATION_REPRESENTATIVE = 5,
  RECYCLER_AND_CONVERTER = 6,
  CONVERTER = 7,
  POLYMERS_ORGANIZATION = 8,
  SORTER = 10,
  SORTER_AND_RECYCLER = 11,
}

export const USER_FIELDS_OF_ACTIVITY = [
  { value: 1, label: "Pipes" },
  { value: 2, label: "Flooring" },
  { value: 3, label: "Roofing/waterproofing" },
  { value: 4, label: "Profiles" },
  { value: 5, label: "Films and sheets" },
]

export interface User {
  id: string
  email: string
  name: string
  lastActive?: Date
  lastActiveEmulate?: Date
  accepted?: Date
  loginAttempts?: string
  blocked?: Date
  role: UserRoles
  companies: Company[]
  company?: Company
  plants?: Company[]
  children?: User[]
  companiesToAttach?: Company[]
  assignedCountries?: Country[]
  registrationFinished?: boolean
  password?: string
  canBeImpersonated?: boolean
  mailAggree?: Boolean
  vinylPlusAgree?: Boolean
}

export interface CreateUserInput {
  email: string
  name: string
  companyId?: number
}

export interface UserIdInput {
  id: number
}

export interface AttachUserToCompanies {
  userId: number
  companyIds: number[]
}

export interface AttachUserToCompanyInput {
  userId: number
  companyId: number
}

export interface UserUpdateInput extends UserIdInput {
  name?: string
  email?: string
  password?: string
  company?: Company
  mailAggree?: boolean
  vinylPlusAgree?: boolean
}

export interface UserCompanies {
  [key: number]: Company[]
}

export interface PutUserInput extends User {
  password?: string
  company?: Company
}

export interface AcceptNotificationInput {
  id: number
}